import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, input } from '@angular/core';

@Component({
  selector: 'floating-popover',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './floating-popover.component.html',
  styleUrls: ['./floating-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FloatingPopoverComponent {
  contentTemplate = input<TemplateRef<unknown> | null>(null);
  contentContext = input<Record<string, unknown> | null>(null);
}
